import { render, staticRenderFns } from "./RanzcrDashboardWidget.vue?vue&type=template&id=0ce60e30&scoped=true"
import script from "./RanzcrDashboardWidget.vue?vue&type=script&lang=js"
export * from "./RanzcrDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./RanzcrDashboardWidget.vue?vue&type=style&index=0&id=0ce60e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce60e30",
  null
  
)

export default component.exports